export default __webpack_public_path__ + "static/media/gas.da54c4c3.png";